import React, { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

// NOTE: Main califormoi landing page is on hold.
// Original imports preserved here for when we bring it back:
// import Header from './components/Header'
// import Hero from './components/Hero'
// import BackgroundSection from './components/BackgroundSection'
// const Featured = lazy(() => import('./components/Featured'))
// const Newsletter = lazy(() => import('./components/Newsletter'))
// const Footer = lazy(() => import('./components/Footer'))

const PorscheApp = lazy(() => import('./features/porsche/PorscheApp'))

const PorscheFallback = () => (
  <div className="min-h-screen bg-black flex items-center justify-center">
    <div className="w-8 h-8 border-2 border-porsche-red border-t-transparent rounded-full animate-spin" />
  </div>
)

// NOTE: Landing component on hold. Uncomment and restore the "/" route to bring it back.
// const Landing: React.FC<{ isInitialized: boolean }> = ({ isInitialized }) => (
//   <div className="min-h-screen bg-black text-white overflow-x-hidden">
//     <Header />
//     <Hero isInitialized={isInitialized} />
//     <BackgroundSection src="/ladyBW-section.png" alt="" focusRightOnMobile />
//     <BackgroundSection src="/cap-camo.png" alt="" />
//     <Suspense fallback={<div className="h-64 bg-black" />}>
//       <Featured />
//       <Newsletter />
//       <Footer />
//     </Suspense>
//   </div>
// )

const App: React.FC = () => (
  <Routes>
    <Route
      path="/porsche/*"
      element={
        <Suspense fallback={<PorscheFallback />}>
          <PorscheApp />
        </Suspense>
      }
    />
    {/* Default: redirect everything to /porsche */}
    <Route path="*" element={<Navigate to="/porsche" replace />} />
  </Routes>
)

export default App
